import React from "react";
import errorpopup from "assets/icons/errorpopup.svg";
import "./ErrorPopupBtn.scss";
import PropTypes from "prop-types";

function ErrorPopupBtn({ setShowErrorPopup }) {
  return (
    <span
      className="popup-information"
      onClick={() => {
        setShowErrorPopup((old) => !old);
      }}
    >
      <img className="popup-img" src={errorpopup} alt="warning-sign" />
    </span>
  );
}

export default ErrorPopupBtn;

ErrorPopupBtn.propTypes = {
  setShowErrorPopup: PropTypes.func,
};
